let btn  = document.querySelector('.cart__checkout');
let checkbox = document.querySelector('.agree');
         
btn.addEventListener('click', (e) =>{
	 if(checkbox.checked){  
          return true;  	  
     }else{
       	  e.preventDefault();
          window.alert("Kindly review and acknowledge our Privacy Policy to proceed.");
          return false;
     }

})

function myFunction() {
   	let regular_price = document.querySelector('.product__price');
  	let sale_price = document.querySelector('.sale-price');
    let regular_price_box = document.querySelector('.regular-price');
  	let sale_promo_price_box = document.querySelector('.sale-promo-price');
    let new_amount = document.querySelector('.custom_total');

  	regular_price_now = (regular_price.innerHTML);
	sale_price_now = (sale_price.innerHTML);

	regular_price_trim = regular_price_now.replace(/[^\d.-]/g, '');
  	sale_price_trim = sale_price_now.replace(/[^\d.-]/g, ''); 
  	
  	regular_price_box.value = regular_price_trim;
	sale_promo_price_box.value = sale_price_trim;
  
    
    if (sale_price_trim < 3000) {
      document.getElementById('installment').style.display = 'none';
    }


    else if ((regular_price_trim > 3000) && regular_price_box.value != '') {
      //Installment computation
      
      a = Number((sale_price_trim * 0.01) * 6);
      b = Number(a) + Number(sale_price_trim);
      c = Number(b / 6).toFixed(2);
      
      d = thousandsSeparator(c);
      
      installment_price = d; 
      
      (new_amount.innerHTML) = installment_price;
      document.getElementById('installment').style.display = 'block';
    }
  
//       if (sale_promo_price_box.value = '') {
//         installment_price = regular_price_trim/6;
//         (new_amount.innerHTML) = installment_price2.toFixed(2);
//         document.getElementById('installment').style.display = 'block';
//         alert(installment_price);
//         alert('Working');
//       }

  
}

function thousandsSeparator(num) {
	var numberParts = num.toString().split(".");
  	numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  	return numberParts.join(".");
}